import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoginService } from './login/login.service';
import { AppService } from './app.service';

@Injectable()
export class MenuService {

    private model : any[];
    private menuSource = new Subject<string>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    constructor(private appService: AppService, public loginService: LoginService) {
    }

    onMenuStateChange(key: string) {
        this.menuSource.next(key);
    }

    reset() {
        this.resetSource.next();
    }

    async getMainMenu(): Promise<any[]> {
        var homeMenu = [];
        var admin = [];
        var superadmin = [];
        if (this.loginService.isLoggedIn()) {
            homeMenu.push(
                { label: 'Tableau de Bord', icon: 'pi pi-desktop', routerLink: ['/dashboard'] }
            );
            var res = await this.appService.loadForms();
            let processMap = new Map();
                for (let item of res) {
                    if (!processMap.get(item.processId.id)) {
                        processMap.set(item.processId.id, item.processId);
                        processMap.get(item.processId.id).fileCount = 0;
                        processMap.get(item.processId.id).forms = [];
                    }
                    processMap.get(item.processId.id).forms.push(item);
                    processMap.get(item.processId.id).fileCount = processMap.get(item.processId.id).fileCount +
                        item.fileCount;
                }
                let index = 1;
                for (let process of processMap.values()) {
                    let processMenu = { label: process.name, icon: 'pi pi-microsoft', items: [], badge: process.fileCount,routerLink: ['/process/' + process.alias] };
                    for (let form of process.forms) {
                        processMenu.items.push({ label: form.name, icon: 'pi pi-align-justify', routerLink: ['/process/' + form.processId.alias + '/form/' + form.code], badge: form.fileCount })
                    }
                    homeMenu.splice(index, 0, processMenu);
                    index = index + 1;
                }
                this.model = [
                    {
                        label: 'Home Menu',
                        items: homeMenu,
                        icon: 'pi pi-home'
                    }];
        }
        if (this.loginService.isLoggedAdmin()) {
            admin.push(
                {label: 'Users', icon: 'pi pi-users', routerLink: ['/admin/users']},
                {label: 'Roles', icon: 'pi pi-key', routerLink: ['/admin/roles']},
                {label: 'Forms', icon: 'pi pi-link', routerLink: ['/admin/forms']}
            );
            this.model.push({
                label: 'Administration',
                items: admin,
                icon: 'pi pi-briefcase'
            });
        }
        if (this.loginService.isLoggedBackendAdmin()) {
            superadmin.push(
                {label: 'Users', icon: 'pi pi-users', routerLink: ['/backendadmin/users']},
                {label: 'Partners', icon: 'pi pi-key', routerLink: ['/backendadmin/partners']},
                {label: 'Partner Groups', icon: 'pi pi-link', routerLink: ['/backendadmin/partner-groups']}
            );
            if (this.loginService.isLoggedSuperAdmin()){
                superadmin.push(
                    {label: 'Process', icon: 'pi pi-link', routerLink: ['backendadmin/processs'], visible: this.loginService.isLoggedAdmin()},
                    {label: 'Configuration', icon: 'pi pi-build', routerLink: ['backendadmin/config'],visible : this.loginService.isLoggedAdmin()}
                );
                
            }
            this.model.push({
                label: 'Backend Administration',
                items: superadmin,
                icon: 'pi pi-briefcase'
            });
        }
        this.model.push({
                label: 'Help',
                icon: 'pi pi-question',
                items: [{ label: 'User manuel', icon: 'pi pi-question', routerLink: ['/help'] },
                        { label: 'FAQ', icon: 'pi pi-question-circle', routerLink: ['/faq'] }]
            });
        var model = this.model;
        return new Promise(function(resolve,reject){
                resolve(model);
            });
    }
}
